import React from "react";
import { Modals, ModalsAction, UserSession, UserSessionAction } from "src/store";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ProfileOutline } from "src/components/svg";
import { Modal } from "src/components/modals/modal";
import { _ } from "src/services";

export const CompleteProfileModal: React.FC = () => {

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: UserSession = useSelector((state: any) => state.UserState);

    const onClose = () => {
        dispatch(ModalsAction.hideCompleteProfile());
        const link = user.user?.profilePromotion?._links?.find((x) => x.rel === "dismiss");
        link && dispatch(UserSessionAction.remindProfileCompleteLater(link));
    }

    const closeModalAfterNavigate = () => {
        dispatch(ModalsAction.hideCompleteProfile());
    }

    const renderFooter = () => {
        return (
            <>
                <div className="col-6 col-md-5">
                    <NavLink to="/profile/edit" onClick={closeModalAfterNavigate} className="w-100 btn focusable btn-submit">{user.user?.profilePromotion?.submitText || _("profilePromotionSubmitText")}</NavLink>
                </div>
                <div className="col-6 col-md-5 offset-md-2">
                    <button onClick={onClose} className="w-100 btn btn-cancel">{user.user?.profilePromotion?.dismissText || _("profilePromotionDismissText")}</button>
                </div>
            </>
        );
    }

    const renderBody = () => {
        const message = user.user?.profilePromotion?.message || _("profilePromotionMessage");
        const innerMessage = user.user?.profilePromotion?.innerMessage || _("profilePromotionInnerMessage");
        return (
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="profile-icon">
                    {user.user?.profilePromotion?.icon ? <img src={user.user?.profilePromotion?.icon} alt="profile" /> : <ProfileOutline />}
                </div>
                <p className="text-center rtl"> {message?.split('%1$s')[0]} <span className="inner-message">{innerMessage}</span> {message?.split('%1$s')[1]}</p>
            </div>
        )
    }

    return (
        <Modal title={user.user?.profilePromotion?.title || _("profilePromotionTitle")} show={modals.completeProfile} onClose={onClose} renderFooter={renderFooter} className="modal-component--login">
            <div className="content text-center">
                {renderBody()}
            </div>
        </Modal>
    );
}